import { noop } from 'lodash';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Menu, Tooltip } from '@mantine/core';
import { IconSignature } from '@tabler/icons-react';
import { useFinishSigningModal } from 'components/modals/finish-signing-modal/FinishSigningModalProvider';
import panic from 'errors/panic';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who is the technician of the revision.
 */
export default function FinishSigningAction({
  revision: { revisionId, kepMessageUuid },
  onStatusChange = noop,
  kind,
}: RevisionSingleActionProps) {
  const { finishSigningModal } = useFinishSigningModal();

  /**
   * Opens the modal to show all revisions with the same kepMessageUuid
   * and allows the user to continue signing.
   */
  const openFinishSigningModal = () => {
    if (!kepMessageUuid) {
      panic(new Error(`No kepMessageUuid found for revision ${revisionId}`));
      return;
    }

    finishSigningModal({
      kepMessageUuid,
      message:
        'Podpisová správa už bola odoslaná do systému BrainIT. Pre dokončenie podpisovania budete presmerovaný do ich webového portálu.',
    });
  };

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Podpísať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={openFinishSigningModal}>
          <IconSignature stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={openFinishSigningModal}
        leftIcon={<IconSignature stroke={1.5} size={24} />}
        variant="secondary"
        w={188}
      >
        Podpísať
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={openFinishSigningModal} icon={<IconSignature stroke={1.5} size={24} />}>
      Podpísať
    </Menu.Item>
  );
}
